import { render } from "./App.vue?vue&type=template&id=7021a122&lang=pug"
import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import "./App.vue?vue&type=style&index=0&id=7021a122&lang=less"

import exportComponent from "/disk2/var/jenkins/workspace/pre__cosmic-mall-h5-entry/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__